



























import mixins from 'vue-typed-mixins';
import E2EMixin from '@/components/mixins/E2EMixin';

export interface AvatarInterface {
  profile_image?: string;
  profile_image_url?: string;
  remove_profile_image?: boolean;
}

export default mixins(E2EMixin).extend({
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    profile_image: {
      type: [Object, File],
      default: null,
    },
    remove_profile_image: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    const hasAvatar = !!this.profile_image;
    return {
      hasAvatar,
      formData: {
        profile_image: this.profile_image,
        profile_image_url: hasAvatar ? this.profile_image.url : null,
        remove_profile_image: false,
      } as AvatarInterface,
    };
  },
  computed: {
    avatarPreviewUrl() {
      return this.hasAvatar
        ? this.formData.profile_image_url
        : '//proff-local.s3-ap-northeast-1.amazonaws.com/images/default-profile-icon.png';
    },
  },
  watch: {
    'formData.profile_image': {
      handler(val) {
        // File Selected from input
        if (val && val instanceof File) {
          this.formData.profile_image_url = URL.createObjectURL(val);
          this.formData.remove_profile_image = false;
          this.hasAvatar = true;
        }
        // Loaded from DB
        else if (val && val instanceof Object && !!val.url) {
          this.formData.profile_image_url = val.url;
          this.formData.remove_profile_image = false;
          this.hasAvatar = true;
        } else {
          this.formData.remove_profile_image = true;
          this.hasAvatar = false;
        }

        this.$emit('change', {
          profile_image: this.formData.profile_image,
          remove_profile_image: this.formData.remove_profile_image,
        });
      },
      immediate: true,
    },
  },
  methods: {
    removeAvatar(e: any) {
      e.preventDefault();
      this.formData.profile_image = null;
      this.formData.profile_image_url = null;
      this.formData.remove_profile_image = true;
    },
  },
});
